import apiUrls from 'apis/apiUrls';
import { axiosInstance } from 'helper/axiosHelper';

const storeService = {
  getStores: (params) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getStores(),
      config: { params },
    });
  },

  getStoresDetails: (params: { cityId: string; zoneId: string }) => {
    return axiosInstance.makeGetRequest({
      url: apiUrls.getStoresDetails(),
      config: { params },
    });
  },

  addStore: (data: any) => {
    return axiosInstance.makePostRequest({
      url: apiUrls.addStore(),
      data,
    });
  },
};

export default storeService;
